module.exports = __webpack_public_path__ + "img/mpu-vorbereitung-online.dae1ba34.jpg";